/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  DetectionClass_Enum,
  detectionClass_EnumFromJSON,
  detectionClass_EnumToJSON,
} from "../../../../gen/detection/detection_class";

export const protobufPackage = "skills";

export interface UnifiedFollowActionArgs {
  range: number;
  azimuth: number;
  classification: DetectionClass_Enum;
}

export interface UnifiedFollowResultData {
}

export interface UnifiedFollowActionStateData {
}

function createBaseUnifiedFollowActionArgs(): UnifiedFollowActionArgs {
  return { range: 0, azimuth: 0, classification: 0 };
}

export const UnifiedFollowActionArgs = {
  encode(message: UnifiedFollowActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.range !== 0) {
      writer.uint32(13).float(message.range);
    }
    if (message.azimuth !== 0) {
      writer.uint32(21).float(message.azimuth);
    }
    if (message.classification !== 0) {
      writer.uint32(24).int32(message.classification);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnifiedFollowActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnifiedFollowActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.range = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.azimuth = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.classification = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnifiedFollowActionArgs {
    return {
      range: isSet(object.range) ? globalThis.Number(object.range) : 0,
      azimuth: isSet(object.azimuth) ? globalThis.Number(object.azimuth) : 0,
      classification: isSet(object.classification) ? detectionClass_EnumFromJSON(object.classification) : 0,
    };
  },

  toJSON(message: UnifiedFollowActionArgs): unknown {
    const obj: any = {};
    if (message.range !== 0) {
      obj.range = message.range;
    }
    if (message.azimuth !== 0) {
      obj.azimuth = message.azimuth;
    }
    if (message.classification !== 0) {
      obj.classification = detectionClass_EnumToJSON(message.classification);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnifiedFollowActionArgs>, I>>(base?: I): UnifiedFollowActionArgs {
    return UnifiedFollowActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedFollowActionArgs>, I>>(object: I): UnifiedFollowActionArgs {
    const message = createBaseUnifiedFollowActionArgs();
    message.range = object.range ?? 0;
    message.azimuth = object.azimuth ?? 0;
    message.classification = object.classification ?? 0;
    return message;
  },
};

function createBaseUnifiedFollowResultData(): UnifiedFollowResultData {
  return {};
}

export const UnifiedFollowResultData = {
  encode(_: UnifiedFollowResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnifiedFollowResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnifiedFollowResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UnifiedFollowResultData {
    return {};
  },

  toJSON(_: UnifiedFollowResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UnifiedFollowResultData>, I>>(base?: I): UnifiedFollowResultData {
    return UnifiedFollowResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedFollowResultData>, I>>(_: I): UnifiedFollowResultData {
    const message = createBaseUnifiedFollowResultData();
    return message;
  },
};

function createBaseUnifiedFollowActionStateData(): UnifiedFollowActionStateData {
  return {};
}

export const UnifiedFollowActionStateData = {
  encode(_: UnifiedFollowActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnifiedFollowActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnifiedFollowActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UnifiedFollowActionStateData {
    return {};
  },

  toJSON(_: UnifiedFollowActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UnifiedFollowActionStateData>, I>>(base?: I): UnifiedFollowActionStateData {
    return UnifiedFollowActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedFollowActionStateData>, I>>(_: I): UnifiedFollowActionStateData {
    const message = createBaseUnifiedFollowActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
